module.exports = __webpack_public_path__ + "img/timeslate-white.5dfd0762.svg";